/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import{property as r}from"./property.js";function o(o,t){const e=t?{...t,source:o}:o;return r({aliasOf:e})}export{o as aliasOf};
